/*eslint-disable*/
import store from '../store/index';

(function (doc, win) {
  // 分辨率Resolution适配
  let docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      let htmlDom = document.getElementsByTagName('html')[0];
      htmlDom.style.fontSize= htmlWidth/20 + 'px';
    };

  // Abort if browser does not support addEventListener
  if (!doc.addEventListener) return;
  window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", hengshuping, false);

  win.addEventListener(resizeEvt, recalc, false);
  win.addEventListener('pageshow', recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

//判断手机横竖屏状态：
function hengshuping(){
  if(window.orientation==180||window.orientation==0){
    store.commit('set_isHorizontal',false);
  }
  if(window.orientation==90||window.orientation==-90){
    store.commit('set_isHorizontal',true);
  }
}



// WEBPACK FOOTER //
// ./src/common/rem/rem.js